<template>
  <div>
    <!-- Pillars Graph -->
    <b-row class="">
      <b-col class="chart">
        <b-card>
          <div class="pillar">
            <h4 v-if="alias == 'GeneralIndex'" align="center">
              {{ getTitle() }}
            </h4>
            <h4 v-else align="center">
              <router-link :to="'/reports/comparative/' + alias">
                {{ $t(getTitle()) }}
              </router-link>
            </h4>
            <b-row>
              <b-col align="center">
                <p class="card-text">
                  {{ $t(getDescription()) }}
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col :sm="12" :lg="6">
                <div class="chart-container">
                  <div class="relative-chart-size">
                    <div
                      :id="alias"
                      class="chart-height"
                      style="min-height: 300px"
                      :style="{
                        height:
                          (chartData.length * 30 > 0
                            ? chartData.length * 30
                            : 20) + 'px',
                      }"
                    />
                  </div>
                </div>
              </b-col>
              <b-col :sm="12" :lg="6" class="pr-5">
                <div style="page-break-after: always">
                  <b-table outlined :fields="fields" :items="formattedItems" />
                </div>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <!-- End Pillars Graph -->
  </div>
</template>

<script>
import { ChartLollipop } from "@/utils/ChartLollipop";
import * as d3 from "d3";

export default {
  name: "CardChartCompare",
  props: {
    alias: null,
    keyValue: null,
    chartData: {},
    title: null,
    description: null,
  },
  data: function () {
    return {
      fields: [],
      indicator: {},
    };
  },
  computed: {
    formattedItems: function () {
      return this.getItemsFormatted();
    },
  },
  methods: {
    getItemsFormatted() {
      const itemsFormatted = [];
      if (this.chartData) {
        this.chartData.map((item) => {
          if (!isNaN(item.index)) {
            itemsFormatted.push({
              index: d3.format(".2f")(item.index),
              businessId: item.businessId,
              businessName: item.businessName,
            });
          } else {
            itemsFormatted.push({
              index: "N/A",
              businessId: item.businessId,
              businessName: item.businessName,
            });
          }
        });
      }
      return itemsFormatted;
    },
    getDescription() {
      return this.description;
    },
    getTitle() {
      return this.title;
    },
    createChart() {
      this.chart = new ChartLollipop(this.alias, this.keyValue, this.chartData);
      this.chart.render();
    },
    refresh() {
      this.chart.refresh();
    },
  },
  mounted() {
    this.createChart();
    this.fields = [
      {
        key: "businessName",
        label: this.$t("label_organization"),
      },
      {
        key: "index",
        label: this.$t("label_reports_genderGap_indexValue_caption"),
      },
    ];
  },
};
</script>
<style lang="scss" scoped>
/* components/cards/CardChartCompare.vue */

@import '../../assets/css/variables.scss';
.chart-height {
  min-height: 90%;
}
@media (min-width: 900px) {
  .chart-height {
    min-height: 85%;
  }
}

@media (min-width: 1250px) {
  .chart-height {
    min-height: 88%;
  }
}

.chart-container {
  width: 100%;
  position: relative;
  display: inline;
}
.pillar {
  text-align: center;
  h4,
  h3 {
    text-transform: uppercase;
    font-size: 1.3rem;
    width: 100%;
  }
  h3 span {
    padding: 0px 17px;
    border-radius: 10px;
  }
  a {
    text-decoration: none;
    color: #000;
  }
}
.b-table {
  font-family: $font-text;
  margin-top: 1rem;
  font-size: 0.8rem;
  th {
    text-align: center;
  }
}
</style>
